import styled from "styled-components";
import { colors } from "../../../theme/colors";
import { Typography, Grid, Button } from "@mui/material";

export const FeaturedPostsContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
`;

export const PostItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
`;

export const PostImageContainer = styled.div`
  flex-shrink: 0;
  width: 75px;
  height: 75px;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

export const PostImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
`;

export const PostContent = styled.div`
  flex: 1;
`;

export const PostTitle = styled.a`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${colors.secondary || "#40c4d4"};
  text-decoration: none;
  display: block;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  cursor: pointer;

  &:hover {
    color: ${colors.primary || "#003865"};
    transition: color 0.3s ease;
  }

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const PostDescription = styled.p`
  color: ${colors.gray?.textLight || "#718096"};
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`;

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid ${colors.secondary || "#40c4d4"};
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 2rem;
  color: #e53e3e;
  font-weight: 500;
`;
